import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";

class SettlementByDateComponent extends Component {
  state = {
    settlementByDateBaseMidRowFields: [
      {
        name: "provider",
        label: "Provider",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "method",
        label: "Method",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "idTPlusX",
        label: "MID",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.25"
      }, {
        name: "name",
        label: "Tags",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "fromDate",
        label: "From Date",
        disabled: true,
        fieldType: "input",
        flexGrow: "0"
      }, {
        name: "toDate",
        label: "To Date",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.3"
      }, {
        name: "pendingPayouts",
        label: "Pending Payouts",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        hideColumn: false
      }, {
        name: "availableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25"
      }, {
        name: "balanceToSettle",
        label: "Balance to Settle",
        fieldType: "input",
        disabled: true,
        flexGrow: "0.25"
      }, {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onMidSelect(index, "SETTLEMENT_BY_DATE"),
        alignSelf: "end",
        disabled: true,
        flexGrow: "0"
      }
    ],
    settlementByDateBaseFields: [
      [
        {
          name: "currency",
          label: "MID Currency",
          disabled: true,
          fieldType: "input",
        },
        {
          name: "availableBalance",
          label: "Total Available Balance",
          fieldType: "input",
          formatValue: true,
          disabled: true,
        },
        {
          name: "balanceToSettle",
          label: "Available Balance Reduction",
          disabled: true,
          fieldType: "input",
          formatValue: true,
        },
        {
          name: "balanceToSettle",
          label: "Balance to Settle",
          disabled: true,
          fieldType: "input",
          formatValue: true,
        },
        {
          name: "propertyId",
          label: "Status",
          fieldType: "select",
          getOptions: () => this.getOptionsFromState("statuses"),
          items: "statuses",
        },
      ],
      [
        { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
        {
          name: "notes",
          label: "Notes",
          fieldType: "textarea",
          flexGrow: "1",
        },
        { fieldType: "button" },
      ]
    ],
    settlementFormByDateTotal: new Form(
      {
        availableBalance: "",
        balanceToSettle: "",
        propertyId: "",
      },
      [
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "propertyId",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    ),
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  };

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.statuses.length !== newProps.statuses.length) {
      this.setState({
        statuses: newProps.statuses,
      });
    }
  };

  populateSettlementByDateForm = (responseMids, controls) => {
    const { settlementByDateBaseMidRowFields, settlementByDateBaseFields, settlementFormByDateTotal } = this.state;
    let SETTLEMENT_BY_DATE = [];
    const settlementFormByDate = [];
    const stateForUpdate = {};

    let availableBalance = 0;
    responseMids.forEach((midInfo) => {
      settlementFormByDate.push(this.getMidRowSettlementByDateForm(midInfo));

      SETTLEMENT_BY_DATE.push(settlementByDateBaseMidRowFields);
      availableBalance += midInfo.runningBalanceAmount ? parseFloat(midInfo.runningBalanceAmount) : 0;
    });

    const notesForm = new Form({
      notes: ""
    }, [{
      name: "notes",
      type: "isString",
      rules: {
        required: false,
      },
    }]);

    Object.assign(settlementFormByDateTotal, {
      availableBalance: parseFloat((availableBalance).toFixed(2)) || 0,
      propertyId: "18",
      currency: controls.currency || "",
      requestedSettlement: availableBalance.toFixed(2).toString() || 0,
      balanceToSettle: parseFloat((availableBalance).toFixed(2)) || 0
    });

    Object.assign(stateForUpdate, {
      settlementFormByDateTotal: settlementFormByDateTotal,
      settlementFormByDateMids: [...settlementFormByDate],
      settlementMids: [...settlementFormByDate]
    });
    SETTLEMENT_BY_DATE.push([]);
    SETTLEMENT_BY_DATE = SETTLEMENT_BY_DATE.concat(settlementByDateBaseFields);
    this.updateField("SETTLEMENT_BY_DATE", SETTLEMENT_BY_DATE);
    settlementFormByDate.push(new Form(), settlementFormByDateTotal, notesForm);
    Object.assign(stateForUpdate, {
      settlementFormByDate: settlementFormByDate
    });
    return stateForUpdate;
  };

  getMidRowSettlementByDateForm = (midInfo) => {
    const { getTXValue } = this.props;
    return new Form(
      {
        id: midInfo.midId,
        idTPlusX: `${midInfo.id} (T+${getTXValue(midInfo.id)})`,
        name: midInfo.name,
        method: midInfo.method,
        provider: midInfo.providerName,
        providerId: midInfo.providerId,
        date: midInfo.date || '',
        fromDate: midInfo.fromDate || '',
        toDate: midInfo.toDate || '',
        pendingPayouts: parseFloat(midInfo.pendingPayouts) || 0,
        availableBalance: parseFloat(midInfo.runningBalanceAmount) || 0,
        balanceToSettle: parseFloat(midInfo.runningBalanceAmount) || 0,
        disabled: false,
        isChecked: true
      },
      [
        {
          name: "id",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "provider",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "method",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "name",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "pendingPayouts",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletType",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "withheldFunds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "disabled",
          type: "isBoolean",
          rules: {
            required: true,
          },
        },
        {
          name: "isChecked",
          type: "isBoolean",
          rules: {
            required: true,
          }
        }
      ]
    );
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    const { settlementByDateBaseMidRowFields } = this.state;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, dataType, midIds } = controls;
      const url = `v1/data/input?clientId=${ merchant }&dataInputTypes=${ dataType }&midIds=${ midIds }&date=${ "24.03.2025" /*controls.date*/ }`;

      crudActions.get(url)
        .then((response) => {
          if (response.length) {
            // Do not display column if value in each row === 0
            const pendingPayoutsField = settlementByDateBaseMidRowFields.find(field => field.name === "pendingPayouts");
            pendingPayoutsField.hideColumn = !response.some(row => row.pendingPayouts !== 0);

            const newState =  this.populateSettlementByDateForm(response, controls);
            Object.assign(newState, {
              showSecondPanel: true,
              loadingDataInput: false,
              lockButton: false,
            });
            this.updateState(newState, settlementByDateBaseMidRowFields);
          } else {
            this.errorUpdate("The selected MIDs has no available balance.");
          }
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  onSaveDataEntries = () => {
    const {form, formTotal, savedData, settlementMids} = this.props;

    const isFormValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isFormValid, isFormValid);

    if (isFormValid) {
      if (formTotal.balanceToSettle > 0) {
        const notes = form[form.length - 1].notes;
        const data = settlementMids.filter(m => m.isChecked && m.balanceToSettle > 0).map((mid) => {
          return {
            id: mid.id,
            name: mid.name,
            method: mid.method,
            pendingPayouts: mid.pendingPayouts,
            runningBalanceAmount: mid.availableBalance,
            balanceToSettle: mid.balanceToSettle,
            currency: formTotal.currency,
            date: mid.date,
            fromDate: mid.fromDate,
            toDate: mid.toDate,
            midId: mid.id,
            providerId: mid.providerId,
            providerName: mid.provider,
            clientId: savedData.merchant,
            propertyId: formTotal.propertyId,
            notes
          };
        });

        crudActions.post(`v1/data/input/settlements`, data)
          .then(() => {
            this.afterSuccessSave("Settlement successfully initiated.");
          }).catch((err) => {
            this.errorUpdate(err ? err.message : '');
          });
      } else {
        this.errorUpdate('Balance to Settle value should be greater than 0! Please, select at least one MID to proceed.');
      }
    }
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default SettlementByDateComponent;